// src/components/ScrollToTop.jsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        // List of paths where you DON'T want to scroll to top
        const excludePaths = [
            // '/chat', // Example: don't scroll on chat page
            // '/panel/messages' // Example: don't scroll on messages
        ];

        // Skip scrolling for excluded paths
        if (excludePaths.some(path => pathname.startsWith(path))) {
            return;
        }

        // Disable browser's automatic scroll restoration
        if ('scrollRestoration' in window.history) {
            window.history.scrollRestoration = 'manual';
        }

        // Immediate scroll
        window.scrollTo(0, 0);

        // Multiple fallback attempts
        const scrollToTop = () => {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
            document.documentElement.scrollTop = 0;
            document.body.scrollTop = 0;
        };

        requestAnimationFrame(scrollToTop);

        const timer1 = setTimeout(scrollToTop, 0);
        const timer2 = setTimeout(scrollToTop, 50);
        const timer3 = setTimeout(scrollToTop, 100);

        return () => {
            clearTimeout(timer1);
            clearTimeout(timer2);
            clearTimeout(timer3);
        };
    }, [pathname]);

    return null;
};

export default ScrollToTop;